"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Close_1 = require("@material-ui/icons/Close");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var paymentTermsAndConditionsModalStyles_1 = require("./paymentTermsAndConditionsModalStyles");
var PaymentTermsAndConditionsModal = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, setIsAccepted = _a.setIsAccepted;
    var styles = paymentTermsAndConditionsModalStyles_1.default();
    var handleAccept = react_1.useCallback(function () {
        setIsAccepted(true);
        setIsOpen(false);
    }, [setIsAccepted, setIsOpen]);
    var handleReject = react_1.useCallback(function () {
        setIsAccepted(false);
        setIsOpen(false);
    }, [setIsAccepted, setIsOpen]);
    return (<core_1.Dialog open={isOpen} className={styles.dialog} classes={{
        paper: styles.dialogPaper,
    }} data-test={'checkout:payment:terms:modal'}>
      <core_1.DialogTitle className={styles.dialogTitle}>
        <core_1.Box className={styles.dialogTitleContent}>
          <core_1.Typography variant={'h4'} data-test={'checkout:payment:terms:title'} className={styles.title}>
            <Translation_1.default id={'trans__checkout__next_step__payment_page_disclaimer__terms_and_condition_label'}/>
          </core_1.Typography>
          <core_1.IconButton className={styles.iconButton} onClick={handleReject} data-test={'checkout:payment:terms:modal:close'}>
            <Close_1.default />
          </core_1.IconButton>
        </core_1.Box>
      </core_1.DialogTitle>
      <core_1.DialogContent className={styles.dialogContent}>
        <core_1.Typography className={styles.disclaimerText} data-test={'checkout:payment:terms:content'}>
          <Translation_1.default id={'trans__checkout__next_step__payment_page_disclaimer__terms_and_condition_modal'}/>
        </core_1.Typography>
      </core_1.DialogContent>
      <core_1.DialogActions className={styles.dialogActions}>
        <core_1.Button color="primary" variant="contained" className={styles.acceptButton} onClick={handleAccept} data-test={'checkout:payment:terms:modal:accept'}>
          <core_1.Typography variant={'caption'}>
            <Translation_1.default id={'trans__checkout__next_step__payment_page_disclaimer__terms_and_condition_modal__agreement_CTA'}/>
          </core_1.Typography>
        </core_1.Button>
      </core_1.DialogActions>
    </core_1.Dialog>);
};
exports.default = PaymentTermsAndConditionsModal;
